import {
  FieldFilter,
  isEqualFilter,
  isNotEqualFilter,
  isInFilter,
  isNotInFilter,
  isLikeFilter,
  isGreaterThanOrEqualFilter,
  isLessThanOrEqualFilter,
  isBetweenFilter,
} from "../FieldFilter.model";
import { FilterMenuItemType } from "../FilterMenu.model";

function isDateFilterValue(filter: FieldFilter) {
  return (
    isBetweenFilter(filter) ||
    isGreaterThanOrEqualFilter(filter) ||
    isLessThanOrEqualFilter(filter)
  );
}
import { SingleFilterMenuItem } from "./SingleFilterMenuItem";
import { MultiFilterMenuItem } from "./MultiFilterMenuItem";
import { SearchFilterMenuItem } from "./SearchFilterMenuItem";
import { BooleanFilterMenuItem } from "./BooleanFilterMenuItem";
import { NumericFilterMenuItem } from "./NumericFilterMenuItem";
import { DateRangeFilterMenuItem } from "./DateRangeFilterMenuItem";

interface FilterMenuItemProps<Field extends string> {
  item: FilterMenuItemType<Field>;
  value?: FieldFilter;
  onChange: (item: FilterMenuItemType<Field>) => void;
  onRequestClose?: () => void;
}

export function FilterMenuItem<Field extends string>({
  item,
  value,
  onChange,
  onRequestClose,
}: FilterMenuItemProps<Field>) {
  return (
    <>
      {item.kind === "single" && (
        <SingleFilterMenuItem<Field>
          {...item}
          value={
            value != null && (isEqualFilter(value) || isNotEqualFilter(value))
              ? value
              : undefined
          }
          onChange={onChange}
        />
      )}

      {item.kind === "multi" && (
        <MultiFilterMenuItem<Field>
          {...item}
          value={
            value != null && (isInFilter(value) || isNotInFilter(value))
              ? value
              : undefined
          }
          onChange={onChange}
        />
      )}

      {item.kind === "search" && (
        <SearchFilterMenuItem<Field>
          {...item}
          value={value != null && isLikeFilter(value) ? value : undefined}
          onChange={onChange}
        />
      )}

      {item.kind === "boolean" && (
        <BooleanFilterMenuItem<Field>
          {...item}
          value={
            value != null && (isEqualFilter(value) || isNotEqualFilter(value))
              ? value
              : undefined
          }
          onChange={onChange}
        />
      )}

      {item.kind === "numeric" && (
        <NumericFilterMenuItem<Field>
          {...item}
          value={
            value != null &&
            (isGreaterThanOrEqualFilter(value) || isLessThanOrEqualFilter(value))
              ? value
              : undefined
          }
          onChange={onChange}
          onRequestClose={onRequestClose}
        />
      )}

      {item.kind === "dateRange" && (
        <DateRangeFilterMenuItem<Field>
          {...item}
          value={
            value != null && isDateFilterValue(value) ? value : undefined
          }
          onChange={onChange}
          onRequestClose={onRequestClose}
        />
      )}
    </>
  );
}
